import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';
import { handleCompleteLater, handleNext, onDidYouReceiveScholarshipChange, populateEndYearOnStartYearChange, onIsPhdToggleChange } from './PostGraduateActions';
import PostGraduateLayout from './PostGraduateLayout';
import { getDomainValueForCode } from '../../../../library/Core/SmartFunctions';
import OutcomeInformationLayout from '../OutcomeInformationLayout';

const PostGraduate = (props: any) => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');
    const location = useLocation();
    const outcomeMatch = location.pathname.includes('outcome')
    console.log("outcomeMatch",outcomeMatch)

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            NEXT: handleNext,
            I_LL_DO_THIS_LATER: handleCompleteLater,
            ROUTER_NAVIGATE: navigate,
            isPhd: onIsPhdToggleChange,
            startYear: populateEndYearOnStartYearChange,
            didYouReceiveScholarship: onDidYouReceiveScholarshipChange,
            REDIRECT: setRedirectUrl
        },
    } as any);

    const { formConfig, data, routeInfo } = useLoaderData() as State;

    // const addIsPhDToggleToFormConfig = (config: any) => {
    //     const updatedConfig = JSON.parse(JSON.stringify(config)); // Deep clone
        
    //     // Find postGradCollegeJoined section
    //     const pgSection = updatedConfig.sectionRepository.find((section: any) => section.id === 'postGradCollegeJoined');
        
    //     if (pgSection && pgSection.controlGroup && pgSection.controlGroup.length > 0) {
    //         const gridControl = pgSection.controlGroup.find((control: any) => control.id === 'postGradCollegeJoined');
            
    //         if (gridControl && gridControl.controlGroup) {
    //             // Check if isPhd toggle already exists
    //             const isPhDExists = gridControl.controlGroup.some((control: any) => control.id === 'isPhd');
                
    //             if (!isPhDExists) {
    //                 // Add the isPhd toggle at the beginning (before universityId)
    //                 gridControl.controlGroup.unshift({
    //                     "id": "isPhd",
    //                     "type": "SWITCH",
    //                     "props": {
    //                         "label": "Is this a PhD program?",
    //                         "defaultValue": false
    //                     },
    //                     "className": "col-md-6",
    //                     "controlGroup": []
    //                 });
    //             }
    //         }
    //     }
        
    //     return updatedConfig;
    // };

    useEffect(() => {
        const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);
        
        // const updatedFormConfig = addIsPhDToggleToFormConfig(formConfig);
        
        // dispatch({
        //     type: 'FORM_CONFIG',
        //     payload: updatedFormConfig
        // });
        
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, domain, routeInfo },
        });
    }, []);

    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    // Trigger PhD toggle logic on page load for any colleges with isPhd already enabled
    useEffect(() => {
        if (!state.flags.isDataLoading && state.data?.postGradCollegeJoined) {
            state.data.postGradCollegeJoined.forEach((college: any) => {
                if (college.isPhd && college.startYear) {
                    onIsPhdToggleChange({
                        value: college.isPhd,
                        row: college,
                        control: { id: 'isPhd' },
                        dispatch: dispatch
                    } as any);
                }
            });
        }
    }, [state.flags.isDataLoading]);

    let message = `Here's How My Post Graduation Went!`
    let outcomeStudiesStatus = ['JOINED_DOCTORAL','HIGHER_STUDIES','JOINED_PG','WENT_FOR_HIGHER_STUDIES']
    if(outcomeStudiesStatus.includes(state?.data?.selectedInstitute?.postProgramCompletionStatusCode)){
        let program_name = getDomainValueForCode(state?.data?.selectedInstitute?.programId,'ALL_PROGRAM_CODE',state)
        // message = `After Completing ${program_name} from ${institute_name}, you mentioned that you went for higher studies. Please provide the details of the institute and course you joined after your program completion at ${institute_name}`
        message =`After ${program_name}, you mentioned that you went for higher studies. Please provide the details.`
    }
    else 
    if(state?.data?.profile?.presentEducationStatusCode == "PURSUING_STUDIES"){
        let program_level = state?.data?.profile?.pursuingEducationLevelCode
        message = `In your education status, you mentioned that you are currently pursuing studies at ${program_level} level. Please provide the details of your Postgrad education.`
    }

    const LayoutComponent = outcomeMatch ? OutcomeInformationLayout : PostGraduateLayout;

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <LayoutComponent> {!state.flags.isDataLoading && <PageBuilder data={message} />}</LayoutComponent>
        </SmartContext.Provider>
    );
};

export default PostGraduate;
